import { ENV_URL_API, ENV_URL_AUTH_SIGNUP, ENV_URL_AUTH_LOGIN, ENV_URL_AUTH_UPDATE, ENV_URL_AUTH_REFRESH, ENV_URL_AUTH_GET_USER_DATA, ENV_WEATHER_API_KEY } from "@env"

export const URL_API = ENV_URL_API
export const URL_AUTH_SIGNUP = ENV_URL_AUTH_SIGNUP
export const URL_AUTH_LOGIN = ENV_URL_AUTH_LOGIN
export const URL_AUTH_UPDATE = ENV_URL_AUTH_UPDATE
export const URL_AUTH_REFRESH = ENV_URL_AUTH_REFRESH
export const URL_AUTH_GET_USER_DATA = ENV_URL_AUTH_GET_USER_DATA
export const WEATHER_API_KEY = ENV_WEATHER_API_KEY
